import { useDispatch } from 'react-redux'
import { createWorkorder, getWorkorders } from 'app/workorder/state/workorder/actions'
import { IWorkorderResponse, SystemAccountType } from '@cbgms/api'
import { query } from '@cbgms/components/list'

/**
 * useGetOrCreateOrderUUIDForEmployee always returns an employee order uuid.
 * If none exists yet, it'll create employee-order.
 */
export const useGetOrCreateOrderUUIDForEmployee = () => {
  const dispatch = useDispatch()

  return async (employeeUUID: string) => {
    // check if employee has an open order.
    const search = query<IWorkorderResponse>()
      .equals(o => o.Workorder.CreatedByUUID, employeeUUID)
      .and()
      .equals(o => o.Account.SystemAccountType, SystemAccountType.WalkIn)
      .and()
      .isNull(o => o.Vehicle.UUID)
    const orders = await dispatch(getWorkorders({ search: search.toString(), orderBy: 'Workorder.CreatedAt|DESC' }))
    if (orders.Data.length) {
      const firstOrder = orders.Data[0]
      return firstOrder.Workorder.UUID
    }

    // no open order, create a new employee order
    const response = await dispatch(createWorkorder())
    return response.Data.UUID
  }
}
